module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/stop-af35e13af150ed6025784a7d6747993e.svg";